module.exports = __webpack_public_path__ + "img/map-right-4.5b38f98c.png";